export default __webpack_public_path__ + "static/media/icon-single-platform-management.9d43c740.svg";